
const Footer = () => {
 

  return (
      <>
          <div className="footer">
           <p>developed with <i className="fa fa-heart"></i> by <a href="https://github.com/procode47"> shadowbytee</a></p> 
          </div>
  
    </>
  );
};

export default Footer;
